import { getRelatedSliderOptions } from "../../../src/js/utils/sliderOptions";

document.addEventListener("DOMContentLoaded", async () => {
	const { initSwiperCarousel } = await import("@utils/swiperCarousel");

	const carousels = document.querySelectorAll(
		".b-related_articles-list_wrapper",
	);

	carousels.forEach((carouselElement) => {
		const options = getRelatedSliderOptions(carouselElement);

		initSwiperCarousel(options, carouselElement, false, true, true);
	});
});
